import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import { Grid, IconButton, Tooltip } from '@material-ui/core'
import { ChevronRight, HomeOutlined } from '@material-ui/icons'

import { generalActions } from 'src/actions/GeneralActions'
import { tooltipDelay } from 'src/Constants'
import { RootState } from 'src/Store'
import { getDataThemeName } from 'src/utils/Utils'

import ModelPicker from '../modelpicker/ModelPicker'
import ThemePicker from '../themepicker/ThemePicker'
import { toolBarStyle } from './ToolBar.style'
import { DataTheme, ToolType } from 'src/Enums'

import VirtualBoreholeSettings from './virtualboreholesettings/VirtualBoreholeSettings'
import ProfileSettings from './profilesettings/ProfileSettings'
import { LayerType } from 'src/dataSources/layers/LayerRegistry'
import { resetSelectedLayers } from 'src/utils/MapLayerUtils'

export interface ToolBarProps { } // eslint-disable-line @typescript-eslint/no-empty-interface

const defaultProps: ToolBarProps = {}

export const ToolBar: FC<ToolBarProps> = (props: ToolBarProps) => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const classes = toolBarStyle()

  const currentDataTheme = useSelector((state: RootState): DataTheme => state.generalState.dataTheme)
  const selectedTool = useSelector((state: RootState): ToolType => state.generalState.selectedTool)
  const enabledLayers = useSelector((state: RootState): LayerType[] => state.mapState.enabledLayers)

  const [themePickerOpen, setThemePickerOpen] = useState(false)

  const handleClose = (): void => {
    setThemePickerOpen(false)
  }

  const handleThemeSelected = (dataTheme: DataTheme): void => {
    if (dataTheme !== currentDataTheme) {
      resetSelectedLayers(enabledLayers, dispatch)
    }
    dispatch(generalActions.setDataTheme(dataTheme))
    setThemePickerOpen(false)
  }

  const homeButtonClicked = (): void => {
    setThemePickerOpen(true)
  }

  const settingsAvailable = (): boolean => {
    return selectedTool === ToolType.VIRTUAL_BOREHOLE || selectedTool === ToolType.PROFILE
  }

  return (
    <div className={classes.root}>
      <Tooltip title={intl.formatMessage({ id: 'toolbar.home' })} enterDelay={tooltipDelay} placement='right'>
        <IconButton size='medium' onClick={homeButtonClicked}>
          <HomeOutlined className={classes.homeIcon} />
        </IconButton>
      </Tooltip>
      <ChevronRight className={classes.breadcrumbSeparator} />
      <div className={classes.breadcrumb}>
        <Tooltip title={getDataThemeName(currentDataTheme)} enterDelay={tooltipDelay} placement='right'>
          <div className={classes.breadcrumbText}>
            {getDataThemeName(currentDataTheme)}
          </div>
        </Tooltip>
      </div>
      <ThemePicker open={themePickerOpen} handleThemeSelected={handleThemeSelected} handleClose={handleClose} />
      {settingsAvailable() && (
        <>
          <div className={classes.separatorBar}>
            |
          </div>
          <div className={classes.toolParamsWrapper}>
            {selectedTool === ToolType.PROFILE &&
              <ProfileSettings />}
            {selectedTool === ToolType.VIRTUAL_BOREHOLE &&
              <VirtualBoreholeSettings />}
          </div>
        </>
      )}
      {!settingsAvailable() && (
        <div className={classes.noToolSelected}>
          <Grid container alignItems='center' />
        </div>
      )}
      <div className={classes.separatorBar}>
        |
      </div>
      <div className={classes.models}>
        <ModelPicker />
      </div>
    </div>
  )
}

ToolBar.defaultProps = defaultProps

export default ToolBar
